import React, { useState } from "react";
import classNames from "classnames";
import { getUserData } from "../auth";

// Import Components
import PendingOrder from "./oders/PendingOrder";
import CustomerOrders from "./oders/CustomerOrders";
import FailedCustomerOrders from "./oders/FailedCustomerOrders";
import SuccessfulCustomerOrders from "./oders/SuccessfulCustomerOrders";
import FailedOrders from "./oders/FailedOrders";
import SuccefullOrder from "./oders/SuccefullOrder";

// Import MUI Icons
import MenuIcon from '@mui/icons-material/Menu'; // Mobile menu icon
import CloseIcon from '@mui/icons-material/Close'; // Close icon
import PendingActionsIcon from '@mui/icons-material/PendingActions'; // Pending Order icon
import CancelIcon from '@mui/icons-material/Cancel'; // Failed Order icon
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Successful Order icon
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'; // Customer Orders icon
import ErrorIcon from '@mui/icons-material/Error'; // Failed Customer Orders icon
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'; // Successful Customer Orders icon

const OrderViewAmazon = () => {
  // Retrieve user data and roles
  const userData = getUserData();
  const roles = userData?.role || [];

  // State to track the active tab
  const [activeTab, setActiveTab] = useState("PendingOrder");
  const [isSidebarActive, setIsSidebarActive] = useState(false);

  // Helper variables for role-based access
  const userHave = roles.some(role => ["ROLE_ADMIN", "ROLE_CUSTOMER", "ROLE_VENDER"].includes(role));
  const canAccessVendorFeatures = roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role));

  // Tab configuration with icons
  const tabs = [
    {
      id: "PendingOrder",
      label: "Pending Order",
      icon: <PendingActionsIcon sx={{ marginRight: 1 }} />,
      component: <PendingOrder />,
      condition: userHave,
    },
    {
      id: "FailedOrder",
      label: "Failed Order",
      icon: <CancelIcon sx={{ marginRight: 1 }} />,
      component: <FailedOrders />,
      condition: userHave,
    },
    {
      id: "SuccefullOrder",
      label: "Successful Order",
      icon: <CheckCircleIcon sx={{ marginRight: 1 }} />,
      component: <SuccefullOrder />,
      condition: userHave,
    },
    {
      id: "CustomerOrders",
      label: "Pending Customers Orders",
      icon: <AssignmentTurnedInIcon sx={{ marginRight: 1 }} />,
      component: <CustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "FailedCustomerOrders",
      label: "Failed Customers Orders",
      icon: <ErrorIcon sx={{ marginRight: 1 }} />,
      component: <FailedCustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "SuccessfulCustomerOrders",
      label: "Successful Customers Orders",
      icon: <VerifiedUserIcon sx={{ marginRight: 1 }} />,
      component: <SuccessfulCustomerOrders />,
      condition: canAccessVendorFeatures,
    }
  ];

  const sidebarController = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  return (
    <section className="contact py-80">
      <div className={`side-overlay ${isSidebarActive && "show"}`} onClick={sidebarController}></div>
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-lg-3">
            <div className={`shop-sidebar ${isSidebarActive && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <CloseIcon />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24 flex items-center gap-2">
                  Orders Management
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  {tabs.filter(tab => tab.condition).map(tab => (
                    <li className="mb-24" key={tab.id}>
                      <a
                        href={`#${tab.id}`}
                        className={classNames("text-gray-900 hover-text-main-600 flex-align gap-8", {
                          "text-main-600 font-semibold": activeTab === tab.id
                        })}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab(tab.id);
                          setIsSidebarActive(false);
                        }}
                        style={{
                          outline: activeTab === tab.id ? '2px solid #EF6036' : 'none',
                          outlineOffset: '2px',
                        }}
                      >
                        {tab.icon} {tab.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          {/* Sidebar End */}

          {/* Content Start */}
          <div className="col-lg-9">
            {/* Mobile Toggle Button */}
            <div className="d-lg-none d-block mb-40">
              <button
                onClick={sidebarController}
                type="button"
                className="w-44 h-44 flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
              >
                <MenuIcon />
              </button>
            </div>

            {/* Main Content */}
            <div className="tab-content">
              {tabs.map(
                tab =>
                  tab.condition && (
                    <div
                      key={tab.id}
                      className={classNames("tab-pane fade", {
                        "show active": activeTab === tab.id,
                      })}
                      id={tab.id}
                      role="tabpanel"
                    >
                      {tab.component}
                    </div>
                  )
              )}
            </div>
          </div>
          {/* Content End */}
        </div>
      </div>
    </section>
  );
};

export default OrderViewAmazon;
